import React from "react";
import { connect } from "react-redux";

function MyMemes({ myMemes }) {
  if (myMemes.length === 0) {
    return (
      <div className="empty-memes-message">
        No memes yet. Pick a template to create your first one!
      </div>
    );
  }

  const urls = myMemes
    .map((meme) => meme.data?.url || meme.url || "")
    .filter(Boolean)
    .reverse();

  return (
    <div className="my-memes-container">
      {urls.map((url) => (
        <a key={url} href={url} target="_blank" rel="noreferrer">
          <img src={url} alt="my meme" className="my-meme-img" />
        </a>
      ))}
    </div>
  );
}

const mapStateToProps = (state) => ({ myMemes: state.myMemes });

export default connect(mapStateToProps)(MyMemes);
